import { Box } from "@chakra-ui/react";
import { Account, Note, TeamSummary } from "common";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar } from "../avatar/Avatar";
import { TeamBanner } from "../utils/TeamBanner";

interface NoteBodyProps {
  note: Note;
  children: any;
}

export const NoteBody = ({ note, children }: NoteBodyProps) => {
  const account: Omit<Account, "roles"> | undefined = useMemo(
    () => note.accounts[0],
    [note]
  );
  const team: TeamSummary | undefined = useMemo(() => note.teams[0], [note]);
  const navigate = useNavigate();
  return (
    <Box
      display={"flex"}
      width={"100%"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      {account ? (
        <Avatar
          config={account.avatarConfig}
          round={true}
          width={"50"}
          height={"50"}
          onClick={() => navigate(`/account/${account.id}`)}
          style={{
            cursor: "pointer",
          }}
        />
      ) : null}
      {children}
      {team ? (
        <TeamBanner
          width={50}
          {...team}
          iconSize={30}
          onClick={() => navigate(`/team/${team.id}`)}
          cursor={"pointer"}
        />
      ) : null}
    </Box>
  );
};
